import api from '@/api/api'

export default {
    async fetchBy(params) {
        try {
            const resp = await api.get(`/api/components`, { params })

            return resp.data
        } catch (err) {
            throw 'Error fetching SIS Import Template Components.'
        }
    },
}
